import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { InsaCronService, LocalizeService } from "../../../../../insa-services";
import { ReportJobDetails, SubReportDetails } from "../../../../../insa-models";
import { SharedMethodsModule } from "../../../../../insa-custom-scripts";

import { ChronosJobListColumnDef } from '../../../';
import { Observable } from "rxjs";

import { customGroupHeader } from '../../../../../insa-custom-scripts'
import { appStateProvider } from "../../../../../insa-providers";
import { ChronosReportListColumnDef } from "../../insa-job-list/job-list-columns";



@Component({
    selector: "subreport",
    template: require("./subreport.component.html")
})

export class SubReportComponent implements OnInit{
    _selectedReportData: any;
    _selectedReportID: any;
    _initSubReportsAll: any;
    isFiltered: boolean = false;
    subReports: SubReportDetails = new SubReportDetails();




    @Input() set selectedReportData(selectedReportData: any) {
        this._selectedReportData = selectedReportData;
        if(this._selectedReportData.ReportID != undefined) this._selectedReportID = this._selectedReportData.ReportID;
        else{
            this._selectedReportID = this._selectedReportData;
            this.isFiltered = true;
        } 
    }

    @Input() set initSubReportsAll(initSubReportsAll: any){
        this._initSubReportsAll = initSubReportsAll;
    }


    @Output() subReportsPicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() subReportClose: EventEmitter<any> = new EventEmitter<any>();

    constructor(private _insaChronosService: InsaCronService, private _appStateProvider: appStateProvider, private _localize: LocalizeService) {}

    ngOnInit(){
        
        if(this._initSubReportsAll != undefined) this.refreshSubReports(this._initSubReportsAll);
    }

    
    refreshSubReports(subReports: any){
        this.InitKendoSubReportGrid(this.createSubReportsGridColumnDefs(), subReports);

    }

    private createSubReportsGridColumnDefs() {

        let subReportListColumnDefs = new Array<ChronosJobListColumnDef>();

        subReportListColumnDefs.push(new ChronosReportListColumnDef("ReportID", "ReportID", true, undefined)); //, '#:(JobID!==null) ? JobID : "" #'
        //if (this.isFiltered == false) subReportListColumnDefs.push(new ChronosReportListColumnDef("SubReportID", "SubReportID", true, undefined)); //, '#:(JobID!==null) ? JobID : "" #'
        //else subReportListColumnDefs.push(new ChronosReportListColumnDef("ReportSubID", "SubReportID", true, undefined)); //, '#:(JobID!==null) ? JobID : "" #'
        subReportListColumnDefs.push(new ChronosReportListColumnDef("SubReportID", "SubReportID", true, undefined)); //, '#:(JobID!==null) ? JobID : "" #'
        subReportListColumnDefs.push(new ChronosReportListColumnDef("ReportPrint", "Status", false, "<input name='ReportPrint' class='holi-check-box' type='checkbox' data-bind='checked: ReportPrint' #= ReportPrint ? checked='checked' : '' #/>", 100))
        subReportListColumnDefs.push(new ChronosReportListColumnDef("ReportName", this._localize.getLocalizedResource('Res1203'), false, '#: (ReportName!==null)? ReportName : ""#')); //, '#:(JobID!==null) ? JobID : "" #'

        return subReportListColumnDefs;
    }

    toggleVisibility(e) {
        console.log(e.target.checked);
    }

    private getSubReportFromRow(e) {
        e.preventDefault();

        let reportList: kendo.ui.Grid = $("#ChronosSubReportList").data("kendoGrid");
        let tr = $(e.target).closest("tr");

        //get selected button action by Id
        let target = e.target || e.srcElement || e.currentTarget;
        let idAttr = target.attributes.id;
        let actionValue = idAttr.nodeValue;
    }

    private InitKendoSubReportGrid(columnDefs, subReportGridData) {
        let subReportDataSourceOptions: kendo.data.DataSourceOptions = {};
        subReportDataSourceOptions.data = subReportGridData;

        subReportDataSourceOptions.schema = {
            model: {
                ReportSubID: { type: "number" },
                fields: {
                    ReportID: { type: "number" },
                    ReportPrint: { type: "boolean" },
                    ReportName: { type: "string", editable: false },
                }
            }
        };
        let subReportDataSource: kendo.data.DataSource = new kendo.data.DataSource(subReportDataSourceOptions);

        let subReportGrid: kendo.ui.Grid = $("#ChronosSubReportList").data("kendoGrid");

        if (subReportGrid == undefined) {
            let subReportGridOptions: kendo.ui.GridOptions = {};
            subReportGridOptions.dataSource = subReportDataSource;
            subReportGridOptions.filterable = false;
            //jobGridOptions.height = '100%';
            subReportGridOptions.sortable = false;
            subReportGridOptions.selectable = true;
            subReportGridOptions.reorderable = false;
            subReportGridOptions.scrollable = false;
            subReportGridOptions.noRecords = { template: SharedMethodsModule.noDataTemplate() };
            subReportGridOptions.pageable = false;
            subReportGridOptions.resizable = false;
            subReportGridOptions.editable = true;

            subReportGridOptions.columns = columnDefs;
            subReportGridOptions.dataBound = customGroupHeader.KendoGridDataBound;
            subReportDataSource.filter({
                logic: "IsEqualTo",
                filters: [{ field: "ReportID", value: this._selectedReportID }]
            });;

            $("#ChronosSubReportList").kendoGrid(subReportGridOptions);
            subReportGrid = $("#ChronosSubReportList").data("kendoGrid");
        }
        else {
            subReportGrid.setDataSource(subReportDataSource);
        }


    }

    saveChanges() {

        let newSubReportsGrid: kendo.ui.Grid = $("#ChronosSubReportList").data("kendoGrid");
        let newSubReports = newSubReportsGrid.dataSource.data().toJSON();
        this.subReportsPicked.emit(newSubReports);
        this.subReportClose.emit(false);
    }

}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/report-job-details/subreport.component.ts